import { DeleteCookie, GetCookie, SetCookie } from "./shareHelper";

const OLD_PASSWORD_HASHING_VALUE_KEY = "isOldPasswordHashing";

interface ReferenceOtpCookie {
  referenceOtp: string;
  referenceOtpLive: number;
  email: string;
}

interface OldPasswordHashingCookie {
  [key: string]: boolean;
}

export const setReferenceOtpCookie = (email: string, referenceOtp: string, referenceOtpLive: number): void => {
  if (!email || !referenceOtp || !referenceOtpLive) {
    console.error("Invalid parameters for setReferenceOtpCookie");
    return;
  }

  const cookieName = `ref_otp_${email.replace(/[^a-zA-Z0-9@._-]/g, "_")}`;
  const cookieValue = JSON.stringify({
    referenceOtp,
    referenceOtpLive,
    email,
  });

  const expireDays = Math.max(1, referenceOtpLive / (24 * 60 * 60));

  SetCookie(cookieName, cookieValue, expireDays);
};

export const getReferenceOtpCookie = (email: string): ReferenceOtpCookie | null => {
  if (!email) {
    console.error("Invalid email for getReferenceOtpCookie");
    return null;
  }

  const cookieName = `ref_otp_${email.replace(/[^a-zA-Z0-9@._-]/g, "_")}`;
  const cookieValue = GetCookie(cookieName);

  if (!cookieValue) return null;

  try {
    const cookieData = JSON.parse(cookieValue);
    // Validate cookie data structure
    if (!cookieData.referenceOtp || !cookieData.referenceOtpLive || !cookieData.email) {
      console.error("Invalid cookie data structure");
      return null;
    }
    return cookieData;
  } catch (error) {
    console.error("Error parsing reference OTP cookie:", error);
    return null;
  }
};

export const removeReferenceOtpCookie = (email: string): void => {
  if (!email) {
    console.error("Invalid email for removeReferenceOtpCookie");
    return;
  }

  const cookieName = `ref_otp_${email.replace(/[^a-zA-Z0-9@._-]/g, "_")}`;
  DeleteCookie(cookieName);
};

export const isReferenceOtpValid = (email: string): boolean => {
  const cookieData = getReferenceOtpCookie(email);
  if (!cookieData) return false;

  const now = new Date();
  const expiryTime = new Date();
  expiryTime.setSeconds(expiryTime.getSeconds() + cookieData.referenceOtpLive);

  return now < expiryTime;
};

export const setOldPasswordHashingCookie = (isOldPasswordHashing: boolean): void => {
  const cookieName = "check_old_pwd_hash";
  const cookieValue = JSON.stringify({
    [OLD_PASSWORD_HASHING_VALUE_KEY]: isOldPasswordHashing,
  });

  SetCookie(cookieName, cookieValue, 365);
};

export const getOldPasswordHashingCookie = (): boolean | null => {
  const cookieName = "check_old_pwd_hash";
  const cookieValue = GetCookie(cookieName);

  if (!cookieValue) return null;

  try {
    const cookieData: OldPasswordHashingCookie = JSON.parse(cookieValue);
    const isOldPasswordHashing = cookieData[OLD_PASSWORD_HASHING_VALUE_KEY];
    return isOldPasswordHashing;
  } catch (error) {
    console.error("Error parsing old password hashing cookie:", error);
    return null;
  }
};

export const clearAllOldPasswordHashingCookies = (): void => {
  const cookieName = "check_old_pwd_hash";

  DeleteCookie(cookieName);
};

export const checkPasswordHashingStatus = (): boolean => {
  const isOldPasswordHashing = getOldPasswordHashingCookie();

  if (isOldPasswordHashing !== null) {
    return !isOldPasswordHashing;
  }

  return true;
};
